// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1hBEZ","boxTitle":"Qualiphy_boxTitle__6gI3c","box":"Qualiphy_box__1aAmO","toggleWrap":"Qualiphy_toggleWrap__3kcS7"};